// extracted by mini-css-extract-plugin
export default {"wrapper":"search-input_drop-down-search_wrapper","inputText":"search-input_drop-down-search_inputText"};